(() => {
  const SELECTOR = '[data-coverax-pdp-drawer]';

  function getDrawer(fromEl) {
    if (!fromEl) return document.querySelector(SELECTOR);
    if (fromEl.matches?.(SELECTOR)) return fromEl;

    const nested = fromEl.closest?.(SELECTOR);
    if (nested) return nested;

    const id = fromEl.getAttribute('aria-controls') || fromEl.dataset.coveraxPdpDrawerOpen;
    if (id) {
      const target = document.getElementById(id);
      if (target?.matches?.(SELECTOR)) return target;
      if (target?.closest?.(SELECTOR)) return target.closest(SELECTOR);
    }

    return document.querySelector(SELECTOR);
  }

  function mountToBody(drawer) {
    if (!drawer || drawer.parentElement === document.body) return;
    document.body.appendChild(drawer);
  }

  function mountAll() {
    document.querySelectorAll(SELECTOR).forEach(mountToBody);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', mountAll, { once: true });
  } else {
    mountAll();
  }

  function openDrawer(drawer, trigger) {
    if (!drawer) return;
    mountToBody(drawer);
    drawer.hidden = false;
    drawer.removeAttribute('hidden');
    drawer.setAttribute('aria-hidden', 'false');
    void drawer.offsetWidth;
    drawer.classList.add('is-open');
    document.body.classList.add('coverax-pdp-drawer-open');
    if (trigger) {
      drawer._coveraxTrigger = trigger;
      trigger.setAttribute('aria-expanded', 'true');
    }
    const panel = drawer.querySelector('.coverax-pdp-drawer__panel');
    const closeBtn = drawer.querySelector('.coverax-pdp-drawer__close');
    const focusTarget = closeBtn || panel;
    if (typeof trapFocus === 'function' && panel) {
      trapFocus(panel, focusTarget);
    } else {
      focusTarget?.focus?.();
    }
  }

  function closeDrawer(drawer) {
    if (!drawer || !drawer.classList.contains('is-open')) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    const trigger = drawer._coveraxTrigger;
    if (trigger) {
      trigger.setAttribute('aria-expanded', 'false');
      drawer._coveraxTrigger = null;
    }
    if (typeof removeTrapFocus === 'function') {
      removeTrapFocus(trigger);
    } else {
      trigger?.focus?.();
    }
    document.body.classList.remove('coverax-pdp-drawer-open');
    const panel = drawer.querySelector('.coverax-pdp-drawer__panel');
    let settled = false;
    const finish = () => {
      if (settled) return;
      settled = true;
      drawer.hidden = true;
      panel?.removeEventListener('transitionend', onEnd);
    };
    const onEnd = (event) => {
      if (event.target !== panel) return;
      finish();
    };
    panel?.addEventListener('transitionend', onEnd);
    setTimeout(finish, 400);
  }

  function activateTab(drawer, key) {
    if (!drawer || !key) return;
    const tabs = drawer.querySelectorAll('[data-coverax-pdp-drawer-tab]');
    const panes = drawer.querySelectorAll('[data-coverax-pdp-drawer-pane]');
    tabs.forEach((tab) => {
      const active = tab.dataset.coveraxPdpDrawerTab === key;
      tab.classList.toggle('is-active', active);
      tab.setAttribute('aria-selected', active ? 'true' : 'false');
      tab.tabIndex = active ? 0 : -1;
    });
    panes.forEach((pane) => {
      const active = pane.dataset.coveraxPdpDrawerPane === key;
      pane.classList.toggle('is-active', active);
      if (active) pane.removeAttribute('hidden');
      else pane.setAttribute('hidden', '');
    });
  }

  document.addEventListener('click', (event) => {
    const openBtn = event.target.closest('[data-coverax-pdp-drawer-open]');
    if (openBtn) {
      event.preventDefault();
      const drawer = getDrawer(openBtn);
      const tabKey = openBtn.dataset.coveraxPdpDrawerTab || 'safety';
      activateTab(drawer, tabKey);
      openDrawer(drawer, openBtn);
      return;
    }

    const closeBtn = event.target.closest('[data-coverax-pdp-drawer-close]');
    if (closeBtn) {
      event.preventDefault();
      closeDrawer(getDrawer(closeBtn));
      return;
    }

    const tab = event.target.closest('[data-coverax-pdp-drawer-tab]');
    if (tab) {
      event.preventDefault();
      const drawer = getDrawer(tab);
      if (!drawer) return;
      activateTab(drawer, tab.dataset.coveraxPdpDrawerTab);
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      document.querySelectorAll(`${SELECTOR}.is-open`).forEach(closeDrawer);
      return;
    }

    const tab = event.target.closest?.('[data-coverax-pdp-drawer-tab]');
    if (
      !tab ||
      (event.key !== 'ArrowLeft' &&
        event.key !== 'ArrowRight' &&
        event.key !== 'Home' &&
        event.key !== 'End')
    ) {
      return;
    }

    const drawer = getDrawer(tab);
    if (!drawer) return;
    const tabs = Array.from(drawer.querySelectorAll('[data-coverax-pdp-drawer-tab]'));
    const index = tabs.indexOf(tab);
    if (index < 0) return;

    let next = index;
    if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
    if (event.key === 'ArrowLeft') next = (index - 1 + tabs.length) % tabs.length;
    if (event.key === 'Home') next = 0;
    if (event.key === 'End') next = tabs.length - 1;

    event.preventDefault();
    tabs[next].focus();
    activateTab(drawer, tabs[next].dataset.coveraxPdpDrawerTab);
  });
})();
